import React, { useEffect, useState, useContext } from 'react'
import apiconfig from '../../config/config';
import APIServices from '../../services/APIServices';
import { EnvironmentContext } from '../../EnvironmentContext';
import { DataGridComponent } from "../../Components/PaginationComponent";
import { useSelector } from 'react-redux';
import moment from "moment";
import "moment-timezone";
import './EventMetrics.css'
import { setAccessToken } from '../../Redux/Actions';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Backdrop, CircularProgress } from '@mui/material';

const EventMetrics = () => {
    const { environment } = useContext(EnvironmentContext);
    const navigate = useNavigate();
    const dispatch = useDispatch()
    const [EventsData, setEventsData] = useState([]);
    const accessToken = useSelector((state) => state.accessToken);
    const [eventCounts, setEventCounts] = useState({
        upcoming: 0,
        finished: 0,
        cancelled: 0,
    });
    const [isLoading, setIsLoading] = useState(false);
    const eventsDataMetrics = useSelector((state) => state.eventMetricsData);

    useEffect(() => {
        const tokenLocal = JSON.parse(localStorage.getItem("token"));
        if (!accessToken && tokenLocal) {
            dispatch(setAccessToken(tokenLocal));
            APIServices.setAuthToken(tokenLocal);
        } else if (!accessToken && !tokenLocal) {
            navigate("/login");
        }
        if (accessToken || tokenLocal) {
            const tokenToUse = accessToken || tokenLocal;
            setIsLoading(true);
            APIServices.setAuthToken(tokenToUse);
            setIsLoading(true)
            const url = environment === "Production"
                ? apiconfig.production.apiBaseUrl
                : apiconfig.develpoment.apiBaseUrl;

            APIServices.setApiBaseUrl(url);
            APIServices.getAllEvents()
                .then((response) => {
                    setIsLoading(false);
                    setEventsData(response.data.Events)
                })
                .catch((err) => {
                    setIsLoading(false);
                    console.log("Error While Fetching All Events: ", err);
                });
        }
    }, [environment, accessToken, navigate, dispatch]);

    useEffect(() => {
        updateEventCounts(EventsData);
    }, [EventsData, environment]);

    const sortedEvents = EventsData.slice().sort((a, b) => {
        return moment(b.event_created_at).diff(moment(a.event_created_at));
    });

    const getTripStatus = (eventDetails) => {
        const checkIsEventEnd = () => {
            const tripEndDate = eventDetails?.end_date;
            const tripEndTime = eventDetails?.end_time;
            const eventTimeZone = eventDetails?.time_zone;
            let convertedTimeZone = eventTimeZone;

            if (eventTimeZone === "IST") {
                convertedTimeZone = "Asia/Kolkata";
            }
            const eventEndStatus = moment.tz(
                tripEndDate + " " + tripEndTime,
                "YYYY-MM-DD HH:mm",
                convertedTimeZone
            );

            const currentDateAndTime = moment.tz(convertedTimeZone);
            if (eventDetails?.event_status === 'cancelled') {
                return false
            } else {
                return currentDateAndTime.isAfter(eventEndStatus);
            }
        };

        const eventTimeZone = eventDetails?.time_zone;
        let convertedTimeZone = eventTimeZone;

        if (eventTimeZone === "IST") {
            convertedTimeZone = "Asia/Kolkata";
        }
        const isEventStarted = moment.tz(
            eventDetails?.start_date + " " + eventDetails?.start_time,
            "YYYY-MM-DD HH:mm",
            convertedTimeZone
        );

        const currentDate = moment.tz(convertedTimeZone);

        const isTripIsOnGoing = () => {
            if (eventDetails?.event_status === 'cancelled') {
                return false
            } else {
                if (currentDate.isBefore(isEventStarted)) {
                    return false;
                } else {
                    return true;
                }
            }
        };

        const isCancelledTrip = () => {
            if (eventDetails.event_status === "cancelled") {
                return true
            }
            else {
                return false
            }
        }
        const isEventEnd = checkIsEventEnd();
        const isTripStarted = isTripIsOnGoing();
        const isCancelled = isCancelledTrip()

        if (isEventEnd) {
            return "Finished";
        } else if (isTripStarted) {
            return "Ongoing";
        } else if (isCancelled) {
            return "Cancelled"
        } else {
            return "Upcoming";
        }
    };

    const updateEventCounts = (events) => {
        const counts = { upcoming: 0, finished: 0, cancelled: 0 };

        events.forEach((event) => {
            const status = getTripStatus(event);
            if (status === "Upcoming") {
                counts.upcoming += 1;
            } else if (status === "Finished") {
                counts.finished += 1;
            } else if (status === 'Cancelled') {
                return counts.cancelled += 1;
            }
            else {
                return
            }
        });

        setEventCounts(counts);
    };

    const getEventType = (event) => {
        if (event?.is_event_free) {
            return "Free Event"
        } else {
            return "Paid Event"
        }
    }


    const columns = [
        {
            field: "event_id",
            headerName: "Event ID",
            width: 150,
            headerClassName: "custom-header"
        },
        {
            field: "event_type",
            headerName: "Event type",
            width: 150,
            cellClassName: "fullname-cell1",
            headerClassName: "custom-header",
        },
        {
            field: "event_location",
            headerName: "Event location",
            width: 150,
            cellClassName: "fullname-cell1",
            headerClassName: "custom-header",
        },
        {
            field: "total_attendees",
            headerName: "Total attendees",
            width: 150,
            cellClassName: "fullname-cell1",
            headerClassName: "custom-header",
        },
        {
            field: "event_date",
            headerName: "Event date",
            width: 200,
            cellClassName: "fullname-cell",
            headerClassName: "custom-header",
        },
        {
            field: "start_location",
            headerName: "Start location",
            width: 200,
            cellClassName: "fullname-cell",
            headerClassName: "custom-header",
        },
        {
            field: "trip_organiser",
            headerName: "Trip organiser",
            width: 200,
            cellClassName: "fullname-cell",
            headerClassName: "custom-header",
        },
        {
            field: "trip_status",
            headerName: "Trip status",
            width: 200,
            cellClassName: "fullname-cell",
            headerClassName: "custom-header",
        },
    ];

    const rows = sortedEvents?.map((item) => {
        const startLocationParts = item?.start_location?.split(',') || [];
        const startLocation = startLocationParts.length >= 2
            ? `${startLocationParts[0]}, ${startLocationParts[1]}`
            : startLocationParts[0] || '';

        const destinationParts = item?.destination?.split(',') || [];
        const destinationLocation = destinationParts.length >= 2
            ? `${destinationParts[0]}, ${destinationParts[1]}`
            : destinationParts[0] || '';

        return {
            id: item?.ID_event,
            _id: item?._id,
            event_id: item?.ID_event,
            event_type: getEventType(item),
            event_location: destinationLocation,
            total_attendees: item?.participants.length,
            event_date: moment(item?.start_date).format("DD/MM/YYYY"),
            start_location: startLocation,
            trip_organiser: item?.organizers,
            trip_status: getTripStatus(item),
        };
    });

    const calculateCountriesCount = (EventsData) => {
        let countriesCount = {};
        EventsData.map((eachEvent) => {
            const startLocationParts = eachEvent.start_location.split(',');
            const startCountry = startLocationParts[startLocationParts.length - 1].trim();

            const destinationParts = eachEvent.destination.split(',');
            const destinationCountry = destinationParts[destinationParts.length - 1].trim();

            // Count events based on start country
            if (countriesCount[startCountry]) {
                countriesCount[startCountry]++;
            } else {
                countriesCount[startCountry] = 1;
            }

            // Count events based on destination country (if different from start)
            if (startCountry !== destinationCountry) {
                if (countriesCount[destinationCountry]) {
                    countriesCount[destinationCountry]++;
                } else {
                    countriesCount[destinationCountry] = 1;
                }
            }
        });

        const sortedCountries = Object.entries(countriesCount)
            .sort((a, b) => b[1] - a[1]); // Sort by count in descending order

        return sortedCountries;
    };

    const countTripsPostedThisMonth = (EventsData) => {
        const currentMonth = moment().month();
        const currentYear = moment().year();

        return EventsData.filter((event) => {
            const eventStartDate = moment(event.start_date);
            const eventMonth = eventStartDate.month();
            const eventYear = eventStartDate.year();

            return eventMonth === currentMonth && eventYear === currentYear;
        }).length;
    };

    return (
        <>
            <Backdrop
                sx={{
                    color: "#ffffff",
                    zIndex: (theme) => theme.zIndex.drawer + 1,
                }}
                open={isLoading}
            >
                <CircularProgress color="inherit" />
            </Backdrop>


            <div className='event-metrics-bg-conatainer'>
                <div className='event-metrics-top-container'>
                    <div className="event-metrics-content-container">
                        <div className="details-content-container">
                            <h5 className="reporting-information-side-heading">Total Events</h5>
                            <p className="reporting-information-content">  {eventsDataMetrics?.totalEvents} </p>
                        </div>
                        <div className="details-content-container">
                            <h5 className="reporting-information-side-heading">Total events engaged</h5>
                            <p className="reporting-information-content"> {countTripsPostedThisMonth(EventsData)} </p>
                        </div>
                        <div className="details-content-container">
                            <h5 className="reporting-information-side-heading">Total paid events</h5>
                            <p className="reporting-information-content"> {eventsDataMetrics?.totalPaidEvents} </p>
                        </div>
                        <div className="details-content-container">
                            <h5 className="reporting-information-side-heading">Total donation events</h5>
                            <p className="reporting-information-content"> NA </p>
                        </div>
                        <div className="details-content-container">
                            <h5 className="reporting-information-side-heading">Total Free events</h5>
                            <p className="reporting-information-content"> {eventsDataMetrics?.totalFreeEvents} </p>
                        </div>
                        <div className="details-content-container">
                            <h5 className="reporting-information-side-heading">Total upcoming events</h5>
                            <p className="reporting-information-content"> {eventsDataMetrics?.totalUpcomingEvents} </p>
                        </div>
                        <div className="details-content-container">
                            <h5 className="reporting-information-side-heading">Total Cancelled events</h5>
                            <p className="reporting-information-content"> {eventsDataMetrics?.totalCancelledEvents} </p>
                        </div>

                    </div>
                    <div className="event-metrics-countries-container">
                        <h5 className='event-metrics-contry-heading'>Total Events by country</h5>
                        {calculateCountriesCount(EventsData).map(([country, count], index) => (
                            <p key={index}>{index + 1}. {country} {count}</p>
                        ))}
                    </div>

                </div>
                <div className='event-metrics-bottom-container'>
                    <DataGridComponent columns={columns} rows={rows} rowCount={rows.length} />
                </div>
            </div>
        </>
    )
}

export default EventMetrics